import { render, staticRenderFns } from "./moobylist.vue?vue&type=template&id=ae649afc&scoped=true"
import script from "./moobylist.vue?vue&type=script&lang=js"
export * from "./moobylist.vue?vue&type=script&lang=js"
import style0 from "./moobylist.vue?vue&type=style&index=0&id=ae649afc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae649afc",
  null
  
)

export default component.exports